





























import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { SliderOrNull, ProgressOrNull } from './types';

@Component
export default class ComponentsFormComponentsrange extends Vue {
  $refs!: {
    bar: HTMLElement,
    slider: HTMLElement
  }

  @Prop({type: Array, required: true})
  scale: Array<number>;

  @Prop({type: Number, required: true})
  value: number;

  @Prop({type: Boolean, default: true})
  showScale: boolean;

  @Prop({type: Boolean, default: false})
  error: boolean;

  size: number = 0;
  offset: number = 0;
  currentValue: number = 0;
  sliderMove: boolean = false;
  sliderStyle: SliderOrNull = null;
  progressStyle: ProgressOrNull = null;

  get slider() {
    return this.$refs.slider;
  }

  get gap() {
    return this.size / (this.scale.length - 1);
  }

  @Watch('value')
  onChangeValue(value: number) {
    const { scale, size } = this;
    if (value == scale[0]) {
      this.valuePosition(0);
    }
    if (value > scale[0] && value < scale.length) {
      this.valuePosition(this.valueStep(value));
    }
    if (value == scale.length) {
      this.valuePosition(size);
    }
  }

  mounted() {
    const { value } = this;
    this.bindEvents();
    this.staticData();
    this.valuePosition(this.valueStep(value));
  }

  beforeDestroy() {
    this.unbindEvents();
  }

  bindEvents() {
    document.addEventListener('mousemove', this.moveSlider);
    document.addEventListener('mouseup', this.moveEnd);
    document.addEventListener('touchmove', this.moveSlider, {passive: false});
    document.addEventListener('touchend', this.moveEnd, {passive: false});
    window.addEventListener('resize', this.refresh);
  }

  unbindEvents() {
    document.removeEventListener('mousemove', this.moveSlider);
    document.removeEventListener('mouseup', this.moveEnd);
    document.removeEventListener('touchmove', this.moveSlider);
    document.removeEventListener('touchend', this.moveEnd);
    window.removeEventListener('resize', this.refresh);
  }

  valueStep(value: number) {
    const { gap } = this;
    return gap * value - gap;
  }

  wrapClick(events: any) {
    if (events.target.className !== 'range__slider') {
      this.valuePosition(this.clickPosition(events));
    }
  }

  staticData() {
    if (this.$refs.bar) {
      this.size = this.$refs.bar.offsetWidth;
      this.offset = this.$refs.bar.getBoundingClientRect().left;
    }
  }

  refresh() {
    if (this.$refs.bar) {
      this.staticData();
    }
  }

  clickPosition(events: any): number {
    return events.clientX - this.offset;
  }

  valuePosition(position: number) {
    const { size, scale, gap } = this;
    if (position >= 0 && position <= size) {
      this.styleElemets(position);
      this.setSurrentValue(Math.round((position + gap) / gap));
    }
    if (position < 0) {
      this.styleElemets(0);
      this.setSurrentValue(scale[0]);
    }
    if (position > size) {
      this.styleElemets(size);
      this.setSurrentValue(scale.length);
    }
  }

  styleElemets(value: number) {
    const { slider, sliderMove } = this;
    if (sliderMove) {
      this.sliderStyle = {left: `${value - slider.scrollWidth / 2}px`, transition: '0s'};
      this.progressStyle = {width: `${value}px`, transition: '0s'};
    } else {
      this.sliderStyle = {left: `${value - slider.scrollWidth / 2}px`};
      this.progressStyle = {width: `${value}px`};
    }
  }

  moveSlider($events: any) {
    if (!this.sliderMove) return;
    if ($events.targetTouches && $events.targetTouches[0]) {
      $events = $events.targetTouches[0];
    }
    this.valuePosition(this.clickPosition($events));
  }

  moveStart() {
    document.body.classList.add('grabbing');
    this.sliderMove = true;
  }

  moveEnd() {
    if (this.sliderMove) {
      document.body.classList.remove('grabbing');
      this.emitCurrentValue();
      this.sliderMove = false;
    }
  }

  setSurrentValue(value: number) {
    this.currentValue = value;
    if (!this.sliderMove) {
      this.emitCurrentValue();
    }
  }

  emitCurrentValue() {
    this.$emit('input', this.currentValue);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/formrange/components/Range.vue